import React from 'react';
import axios from 'axios';
import saveAs from 'file-saver';

import PageHeader from '../../Common/PageHeader';
import Table from '../../Common/Table';

import TenantService from '../../../Service/TenantService';
import Loader from '../../../Component/Common/Loader';
import { toastError, toastForTenant } from '../../../SweetAlertUtil/util';
import { hot } from 'react-hot-loader';

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_tenant: null,
			_forms: null,
			_isLoading: false,
			_tenantLoaded: false
			// _fileUploaded: null
		};
	}

	onChange = async (e, key) => {
		let _forms = this.state._forms;
		_forms = {
			_key: key,
			_fileUploaded: e.target.files[0] || null
		};
		await this.setState({
			_forms: _forms
		});
	};

	uploadNewForm = async key => {
		try {
			let _forms = this.state._forms;
			this.setState({ _isLoading: true });
			const requestBody = {
				formKey: key
			};
			const response = await TenantService.updateForm(this.props.match.params.id, requestBody);
			await axios.put(response.signedUrl, this.state._forms._fileUploaded, {
				headers: {
					'Content-Type': 'text/html'
				}
			});
			await TenantService.invalidateCache();
			_forms = null;
			this.setState({ _isLoading: false, _forms });
			if (response) {
				toastForTenant('Your Form is Updated');
			} else {
				toastError('something went wrong');
			}
		} catch (error) {
			this.setState({ _isLoading: false, _forms: null });
			toastError('something went wrong');
		}
	};

	downloadForm = async key => {
		this.setState({ _isLoading: true });
		const requestBody = {
			formKey: key
		};
		const response = await TenantService.downloadForm(this.props.match.params.id, requestBody);
		const link = response.signedUrl;
		axios({
			url: link,
			method: 'GET',
			responseType: 'blob'
		}).then(res => {
			window.URL.createObjectURL(new Blob([res.data]));
			var blob = new Blob([res.data], {
				type: 'text/html'
			});
			saveAs(blob, key);
		});
		if (response) {
			this.setState({ _isLoading: false });
		}
	};

	fetchAllForms = async () => {
		const response = await TenantService.getAllForms(this.props.match.params.id);
		return {
			forms: response,
			total: response.length
		};
	};

	getTenant = async () => {
		this.setState({ _tenantLoaded: true });
		const response = await TenantService.getById(this.props.match.params.id);
		this.setState({
			_tenant: response,
			_tenantLoaded: false
		});
	};

	isUplaodButtonDisable = value => {
		let result = false;
		if (this.state._forms === null) {
			result = true;
		} else if (this.state._forms !== null) {
			result = true;
			if (this.state._forms._key === value) {
				result = false;
			}
		}
		return result;
	};

	returnLabelForFileUplaod = value => {
		if (this.state._forms !== null) {
			if (this.state._forms._key === value) {
				return this.state._forms._fileUploaded.name;
			}
			return 'Choose file';
		} else {
			return 'Choose File';
		}
	};

	componentDidMount() {
		this.getTenant();
	}

	render() {
		if (this.state._tenantLoaded) {
			return 'Loading...';
		}

		const columns = [
			{
				name: 'Key',
				label: '#',
				options: {
					customBodyRender: (_value, obj) => {
						return obj.rowIndex + 1;
					}
				}
			},
			{
				name: 'Key',
				label: 'Form Name',
				options: {
					filter: true,
					sort: true
				}
			},
			{
				name: 'Key',
				label: 'Action',
				options: {
					sort: false,
					customBodyRender: (value, _obj) => {
						return (
							<button
								className="btn btn-block btn-primary"
								onClick={() => {
									this.downloadForm(value);
								}}
								type="button">
								Download
							</button>
						);
					}
				}
			},
			{
				name: 'Key',
				label: 'Update Forms',
				options: {
					sort: false,
					display: this.state._tenant !== null ? !this.state._tenant.is_default : true,
					customBodyRender: (value, _obj) => {
						return (
							<td style={{ display: 'flex' }}>
								<div className="custom-file">
									<input
										className="custom-file-input"
										id="customFile"
										name="customFile"
										onChange={e => this.onChange(e, value)}
										type="file"
									/>
									<label className="custom-file-label overflow-hidden" htmlFor="customFile">
										{this.returnLabelForFileUplaod(value)}
									</label>
								</div>
								<button
									className="btn btn-block btn-success"
									disabled={this.isUplaodButtonDisable(value)}
									onClick={() => {
										this.uploadNewForm(value);
									}}
									style={{ width: '30%', marginLeft: '10px' }}
									type="button">
									Upload
								</button>
							</td>
						);
					}
				}
			}
		];

		return (
			<>
				<PageHeader text={`Forms - ${this.state._tenant !== null ? this.state._tenant.short_name : ''}`} />
				<Table columns={columns} dataSourceHandler={this.fetchAllForms} dataSourceName="forms" />
				{this.state._isLoading ? <Loader /> : null}
			</>
		);
	}
}

export default hot(module)(Index);
